import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CommonHelper } from 'src/utils/commonHelper';
import { LocalStorage } from 'src/utils/storage/local-storage';
import InitializeGoogleTagManager from 'src/utils/tagManagerInitialize';
import WelcomeImage from '../../assets/app-image/welcome.svg';
import { CookieStorage } from 'src/utils/storage/cookie-storage';
import { Config } from 'src/config';

const StyledContent = styled('div')(({ theme }) => ({
  minWidth: 600,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

const WelcomePageForLifeTimeUserComponent = () => {
  const { t: translate } = useTranslation();

  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      let userInfo = CommonHelper.GetBrandInfoFromLocalStorage('user_details')
      if (userInfo) {
        InitializeGoogleTagManager(userInfo.email);
        navigate('/get-started');
      } else navigate('/login');
    }, 3000);

    const affiliateId = CookieStorage.getCookie("affiliate_id");
    const configAffiliateId = Config?.FacebookAdManager?.affiliateId;

    if (affiliateId === configAffiliateId) {
      navigate('/welcome-ad-lifetime');
    }

    // Google Ads conversion event snippet
    const script = document.createElement('script');
    script.innerHTML = "gtag('event', 'conversion', {'send_to': 'AW-11309238073/y35yCJbCjdQaELmO1ZAq'});";
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
      clearTimeout(timer);
    };
  }, []);
  return (
    <>
      <Helmet>
        <title> {translate('welcome_page.welcome')} </title>
      </Helmet>
      <Dialog aria-labelledby="customized-dialog-title" open maxWidth="xl">
        <DialogContent dividers>
          <StyledContent sx={{ textAlign: 'center', alignItems: 'center', mt: 5 }}>
            <Typography variant="h3" paragraph>
              {translate('welcome_page.welcome_two')}
            </Typography>

            <Typography sx={{ color: 'text.secondary' }}>
              {CommonHelper.GetAppName()}, {translate('welcome_page.social_scheduler')}
            </Typography>

            <Box component="img" src={WelcomeImage} />
          </StyledContent>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default WelcomePageForLifeTimeUserComponent;
